// collection page accordion js.

  $('.acnav__label').click(function () {
	 var label = $(this);
	   var parent = label.parent('.has-children');
	     var list = label.siblings('.acnav__list');

	if ( parent.hasClass('is-open') ) {
       label.removeClass("icon-new");
		  list.slideUp('200');
		   parent.removeClass('is-open');
	  }
	else {
       label.addClass("icon-new");
		 list.slideDown('200');
		 parent.addClass('is-open');
	}
 });

// COLLECTION page list view and grid view js.
  
  $(".produts-listingg").click(function(){
    $("#ProductGridContainer").addClass("list-view");
    $(".produts-blockk").removeClass("active");
   $(".produts-listingg").addClass("active");
      $("ul#product-grid").removeClass("grid--4-col-desktop list-produts");
         $("ul#product-grid").addClass("grid--1-col-tablet-down grid--1-col-desktop list-produts");
        if($("#product-grid").hasClass("grid product-grid grid--2-col-tablet-down grid--3-col-desktop grid--1-col-tablet-down grid--1-col-desktop list-produts")){     
         $('.description-collection-page').show();
       }
   
     });
     $(".produts-blockk").click(function(){
         $("#ProductGridContainer").removeClass("list-view");
           $(".produts-listingg").removeClass("active");
           $(".produts-blockk").addClass("active");
           $("ul#product-grid").removeClass("grid--1-col-tablet-down grid--1-col-desktop list-produts");
              $("ul#product-grid").addClass("grid--4-col-desktop");
        $('.description-collection-page').hide();
      
       });

   $('.texti-sliders').slick({
   dots: true,
   infinite: true,
   speed: 500,
   slidesToShow: 1,
   slidesToScroll: 1,
   autoplay: false,
   autoplaySpeed: 2000,
   arrows: false
  });
   
 

// Home Page Categories Tab js.
/*
 function openTab(evt, cityName) {
   var i, tabcontent, tablinks;
      tabcontent = document.getElementsByClassName("tabcontent-cus");
         for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
       }
  tablinks = document.getElementsByClassName("tablinks-cus");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
   }
  document.getElementById(cityName).style.display = "block";
    evt.currentTarget.className += " active";
   }

  document.getElementById("tab-cus-active").click();

 */




   